import { createSelector } from 'reselect';

const selectProductInsights = (state: any) => state.productInsights;


export const selectProductInsightsCurrentItem = createSelector([selectProductInsights], (productInsights) => productInsights.current);

export const selectProductInsightsListItems = createSelector([selectProductInsights], (productInsights) => productInsights.list);

export const selectProductInsightsItemById = (itemId: any) =>
    createSelector(selectProductInsightsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectProductInsightsQueryItems = createSelector([selectProductInsights], (productInsights) => productInsights.query);

export const selectProductInsightsCreatedItem = createSelector([selectProductInsights], (productInsights) => productInsights.create);

export const selectProductInsightsUpdatedItem = createSelector([selectProductInsights], (productInsights) => productInsights.update);

export const selectProductInsightsCancelledItem = createSelector([selectProductInsights], (productInsights) => productInsights.cancel);

export const selectProductInsightsReturnedItem = createSelector([selectProductInsights], (productInsights) => productInsights.return);

export const selectProductInsightsReadItem = createSelector([selectProductInsights], (productInsights) => productInsights.read);

export const selectProductInsightsPrintItem = createSelector([selectProductInsights], (productInsights) => productInsights.print);

export const selectProductInsightsDeletedItem = createSelector([selectProductInsights], (productInsights) => productInsights.delete);

export const selectProductInsightsSearchedItems = createSelector([selectProductInsights], (productInsights) => productInsights.search);

export const selectProductInsightsItemsCount = createSelector([selectProductInsights], (productInsights) => productInsights.count);

export const selectProductInsightsItemsFilter = createSelector([selectProductInsights], (productInsights) => productInsights.filter);

export const selectProductInsightsSummaryItems = createSelector([selectProductInsights], (productInsights) => productInsights.summary);